import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { withRouter } from 'react-router-dom';
import { get } from 'lodash';

import Header from 'components/Header';
import { Grid, Column } from 'components/Layout';
import { Button } from 'components/Button';

import thumbUp from 'assets/icons/circle-declined.svg';
import style from './style.scss';

const Approved = ({ history }) => {
  const data = useSelector(state => get(state, 'workflow.state.data', {}));

  const handleButtonClick = (e) => {
    e.preventDefault();

    history.push('/dashboard');
  };

  return (
    <Fragment>
      <Header />
      <section className="container section">
        <div className={cn('grid-container fluid', style['pre-selection-failed-page'])}>
          <div className="grid-container">
            <Grid className="grid-margin-x max-limited">

              <Column className="small-12 large-8 large-offset-2">
                <img src={thumbUp} alt="congrats" />
                <h2>Unfortunately, {data.applicantName} is not<br />pre-selected at this time.</h2>
                <Button
                  id="FormSubmit"
                  className="button large arrow green"
                  onClick={handleButtonClick}
                >
                  To Dashboard
                </Button>
              </Column>

            </Grid>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

Approved.propTypes = {
  history: PropTypes.object.isRequired,
};

Approved.defaultProps = {

};

export default withRouter(Approved);



// WEBPACK FOOTER //
// ./src/containers/pages/PreSelection/Failed/index.js